import React from 'react';
import { Navigate } from 'react-router-dom';

const Home = () => {
    return (
        <Navigate to={process.env.PUBLIC_URL + '/Lobby'} />
    )
}

export default Home;